var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "review-widget-wrapper" },
      [
        _c("h2", [_vm._v(" Thanks for saving your details ")]),
        _c("Notice", {
          attrs: {
            id: "tuo-confirm-success-message",
            header: "Personal information is saved.",
            "notice-type": "SUCCESS"
          }
        }),
        _c("PiSecure"),
        _c("p", [
          _vm._v(
            " To review and manage your personal information, log in to your MyServiceNSW account. "
          )
        ]),
        _c(
          "Button",
          {
            attrs: { id: "tuo-goto-myservicensw-button", secondary: "" },
            on: { click: _vm.goToMyServiceNSW }
          },
          [_vm._v(" Log in to account ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }